/**
 * Unions Catalog Hook
 */

import { useState, useEffect } from 'react';
import { unionsCatalogService } from '../unions.service.ts';
import type { Union } from '../unions.types.ts';


interface UseUnionsResult {
  unions: Union[];
  loading: boolean;
  error: string | null;
}

export function useUnions(): UseUnionsResult {
  const [unions, setUnions] = useState<Union[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    void (async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await unionsCatalogService.getUnions();

        if (!isMounted) return;

        if (response.success && response.data) {
          setUnions(response.data);
        } else if (response.error) {
          setError(response.error.description || 'Error loading unions');
        }
      } catch (catchError) {
        if (!isMounted) return;
        setError(catchError instanceof Error ? catchError.message : 'Unknown error');
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  return { unions, loading, error };
}
